import React from 'react'

export const DetalleDotacion = () => {
  return (
    <div>DetalleDotacion</div>
  )
}
